import { render } from "./About.vue?vue&type=template&id=5537cdaa&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=5537cdaa&scoped=true&lang=css"

import exportComponent from "/Users/djones/Desktop/repos/davyjones-me/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5537cdaa"]])

export default __exports__